var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 .5v1.25L4.156.969c1.188-.281 2.438-.156 3.532.406a5.163 5.163 0 004.593 0l.313-.156C13.219.906 14 1.375 14 2.094v8.719c0 .437-.281.78-.656.937l-1.094.406c-1.438.563-3.031.469-4.438-.219A5.56 5.56 0 004 11.5l-3 .75v3.25c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V.5C0 .25.219 0 .5 0c.25 0 .5.25.5.5zm0 2.281v8.438l2.75-.688a6.677 6.677 0 014.531.5 4.571 4.571 0 003.625.188L13 10.813V2.124l-.281.125a6.025 6.025 0 01-5.469 0 4.353 4.353 0 00-2.875-.313L1 2.781z"
  })));
}
export default SvgFlagIcon;